import { FacebookIcon } from '../icons/facebook';
import { InstagramIcon } from '../icons/instagram';
import { LinkedInIcon } from '../icons/linkedin';
import { XIcon } from '../icons/x';
import { YouTubeIcon } from '../icons/youtube';
import { ComplianceLink } from './footer-compliance-links';
import { ContactsData } from './footer-contacts';
import { SocialItem } from './footer-socials';

export const montefioreSocialLinks: SocialItem[] = [
  {
    href: 'https://twitter.com/MontefioreNYC',
    ariaLabel: 'Follow us on Twitter, opens in new tab',
    analyticsText: 'x',
    icon: <XIcon />,
  },
  {
    href: 'https://www.facebook.com/montefioremedicalcenter',
    ariaLabel: 'Like us on Facebook, opens in new tab',
    analyticsText: 'facebook',
    icon: <FacebookIcon />,
  },
  {
    href: 'https://www.linkedin.com/company/montefiore-health-system',
    ariaLabel: 'Find us on LinkedIn, opens in new tab',
    analyticsText: 'linkedin',
    icon: <LinkedInIcon />,
  },
  {
    href: 'https://www.instagram.com/montefiorehealthsystem',
    ariaLabel: 'Follow us on Instagram, opens in new tab',
    analyticsText: 'instagram',
    icon: <InstagramIcon />,
  },
  {
    href: 'https://www.youtube.com/user/MontefioreMedCenter',
    ariaLabel: 'Watch us on YouTube, opens in new tab',
    analyticsText: 'youtube',
    icon: <YouTubeIcon />,
  },
];

export const einsteinSocialLinks: SocialItem[] = [
  {
    href: 'https://twitter.com/EinsteinMed',
    ariaLabel: 'Follow us on Twitter, opens in new tab',
    analyticsText: 'x',
    icon: <XIcon />,
  },
  {
    href: 'https://www.facebook.com/EinsteinCollegeofMedicine',
    ariaLabel: 'Like us on Facebook, opens in new tab',
    analyticsText: 'facebook',
    icon: <FacebookIcon />,
  },
  {
    href: 'https://www.linkedin.com/school/albert-einstein-college-of-medicine',
    ariaLabel: 'Find us on LinkedIn, opens in new tab',
    analyticsText: 'linkedin',
    icon: <LinkedInIcon />,
  },
  {
    href: 'https://www.instagram.com/einsteinmed',
    ariaLabel: 'Follow us on Instagram, opens in new tab',
    analyticsText: 'instagram',
    icon: <InstagramIcon />,
  },
  {
    href: 'https://www.youtube.com/user/EinsteinCollegeofMed',
    ariaLabel: 'Watch us on YouTube, opens in new tab',
    analyticsText: 'youtube',
    icon: <YouTubeIcon />,
  },
];

export const patientCareInfo: ContactsData = {
  title: 'montefiore.patientCare',
  phone: '718-920-4321',
  location: {
    href: 'https://www.google.com/maps/place/Montefiore+Hospital/@40.8798864,-73.8799255,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2f30d1c212ae7:0xbe0664e95268c8fc!8m2!3d40.8798864!4d-73.8799255!16s%2Fm%2F04g3m6g',
    text: '111 East 210th Street\nBronx, NY 10467',
  },
  socials: montefioreSocialLinks,
};

export const albertEinsteinMedicine: ContactsData = {
  title: 'montefiore.albert',
  phone: '718-430-2000',
  location: {
    href: 'https://www.google.com/maps/place/Albert+Einstein+College+of+Medicine/@40.8504961,-73.8484771,17z/data=!3m2!4b1!5s0x89c2f4abaafa5ec3:0x78366f6d5fc302ef!4m6!3m5!1s0x89c2f520102d0015:0x811711422dfb0bbe!8m2!3d40.8504961!4d-73.8459022!16zL20vMDF2YzRy',
    text: 'Jack and Pearl Resnick Campus\n1300 Morris Park Avenue\nBronx, NY 10461',
  },
  socials: einsteinSocialLinks,
};

export const findCareLinks = [
  {
    href: 'https://montefioreeinstein.org/profiles',
    text: 'montefiore.findADoctor',
    analyticsText: 'Find a Doctor',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/locations',
    text: 'montefiore.locations',
    analyticsText: 'Locations',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/services/primary-care/mmg/urgent-care',
    text: 'montefiore.urgentCare',
    analyticsText: 'Urgent Care',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/services/virtual-urgent-care',
    text: 'montefiore.virtualUrgentCare',
    analyticsText: 'Virtual Urgent Care',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/emergency',
    text: 'montefiore.emergencyCare',
    analyticsText: 'Emergency Care',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/doctor-video-visits',
    text: 'montefiore.doctorVideoVisits',
    analyticsText: 'Doctor Video Visits',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/services',
    text: 'montefiore.allClinicalServices',
    analyticsText: 'All Clinical Services',
  },
];

export const patientResourcesLinks = [
  {
    href: 'https://montefioreeinstein.org/patient-care/patients-visitors',
    text: 'montefiore.patientAndVisitorInformation',
    analyticsText: 'Patient and Visitor Information',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/patients-visitors/billing-insurance',
    text: 'montefiore.billingAndInsurance',
    analyticsText: 'Billing and Insurance',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/patients-visitors/billing-insurance/online-bill-pay',
    text: 'montefiore.payHospitalBillsOnline',
    analyticsText: 'Pay Hospital Bills Online',
  },
  {
    href: 'https://www.healthwise.net/montefiore/',
    text: 'montefiore.patientHealthLibrary',
    analyticsText: 'Patient Health Library',
  },
  {
    href: 'https://montefioreeinstein.findhelp.com/',
    text: 'montefiore.findHelp',
    analyticsText: 'Findhelp®',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/patients-visitors/billing-insurance/paying-for-your-care',
    text: 'montefiore.priceTransparency',
    analyticsText: 'Price Transparency',
  },
  {
    href: 'https://www.changehealthcare.com/hipaa-substitute-notice.html',
    text: 'montefiore.changeHealthcareHIPAASubstituteNotice',
    analyticsText: 'Change Healthcare HIPAA Substitute Notice',
  },
];

export const researchAndEducationLinks = [
  {
    href: 'https://montefioreeinstein.org/research/clinical-trials',
    text: 'montefiore.clinicalTrials',
    analyticsText: 'Clinical Trials',
  },
  {
    href: 'https://montefioreeinstein.org/research',
    text: 'montefiore.research',
    analyticsText: 'Research',
  },
  {
    href: 'https://einsteinmed.edu',
    text: 'montefiore.albert',
    analyticsText: 'Albert Einstein College of Medicine',
  },
  {
    href: 'https://einsteinmed.edu/education/md-program/',
    text: 'montefiore.medicalEducation',
    analyticsText: 'Medical Education',
  },
  {
    href: 'https://montefioreeinstein.org/education/gme',
    text: 'montefiore.graduateMedicalEducation',
    analyticsText: 'Graduate Medical Education',
  },
  {
    href: 'https://montefioreeinstein.org/education/school-of-nursing',
    text: 'montefiore.schoolOfNursing',
    analyticsText: 'School of Nursing',
  },
  {
    href: 'https://einsteinmed.edu/faculty/directory',
    text: 'montefiore.findFaculty',
    analyticsText: 'Find Faculty',
  },
];

export const connectLinks = [
  {
    href: 'https://montefioreeinstein.org/news',
    text: 'montefiore.newsroom',
    analyticsText: 'Newsroom',
  },
  {
    href: 'https://montefioreeinstein.org/news/search?f%5B0%5D=category%3A1631',
    text: 'montefiore.newsReleases',
    analyticsText: 'News Releases',
  },
  {
    href: 'https://montefioreeinstein.org/news/contacts',
    text: 'montefiore.mediaContacts',
    analyticsText: 'Media Contacts',
  },
  {
    href: 'https://montefioreeinsteinnow.org/',
    text: 'montefiore.montefioreEinsteinUPDATE',
    analyticsText: 'Montefiore Einstein UPDATE',
  },
  {
    href: 'https://events.montefioreeinstein.org',
    text: 'montefiore.events',
    analyticsText: 'Events',
  },
];

export const aboutLinks = [
  {
    href: 'https://montefioreeinstein.org/giving',
    text: 'montefiore.giving',
    analyticsText: 'Giving',
  },
  {
    href: 'https://montefioreeinstein.org/community',
    text: 'montefiore.community',
    analyticsText: 'Community',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/locations',
    text: 'montefiore.locations',
    analyticsText: 'Locations',
  },
  {
    href: 'https://montefioreeinstein.org/supplychain',
    text: 'montefiore.supplyChain',
    analyticsText: 'Supply Chain',
  },
  {
    href: 'https://careers.montefiore.org',
    text: 'montefiore.careers',
    analyticsText: 'Careers',
  },
];

export const topLinks = [
  {
    href: 'https://montefioreeinstein.org',
    text: 'montefiore.montefioreEinstein',
    analyticsText: 'Montefiore Einstein',
    animation: 'default',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care',
    text: 'montefiore.patientCare',
    analyticsText: 'Patient Care',
    animation: 'reverse',
  },
  {
    href: 'https://einsteinmed.edu',
    text: 'montefiore.albert',
    analyticsText: 'Albert Einstein College of Medicine',
    animation: 'reverse',
  },
  {
    href: 'https://www.cham.org/',
    text: 'montefiore.childrens',
    analyticsText: 'Children’s Hospital',
    animation: 'reverse',
  },
];

export const complianceLinks: ComplianceLink[] = [
  {
    href: 'https://montefioreeinstein.org/patient-care/privacy-policy',
    analyticsText: 'Notice of Privacy Practices – Health Information',
    text: 'montefiore.noticeOfPrivacyPractices',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/privacy-policy/web-mobile',
    analyticsText: 'Privacy Policy – Web and Mobile Applications',
    text: 'montefiore.privacyPolicy',
  },
  {
    href: 'https://montefioreeinstein.org/patient-care/compliance-hotline',
    analyticsText: 'Compliance Hotline',
    text: 'montefiore.complianceHotline',
  },
  {
    onClick: (): void => {
      // This object is placed on the window by the OneTrust script,
      // which is included in the mcc cookie banner.
      const OneTrust = window.OneTrust as
        | { ToggleInfoDisplay: () => void }
        | undefined;
      if (OneTrust?.ToggleInfoDisplay) {
        OneTrust.ToggleInfoDisplay();
      }
    },
    analyticsText: 'Cookie Preferences',
    text: 'montefiore.cookiePreferences',
  },
];

export const accordionData = [
  {
    id: 'find-care',
    title: 'montefiore.findCare',
    links: findCareLinks,
  },
  {
    id: 'patient-resources',
    title: 'montefiore.patientResources',
    links: patientResourcesLinks,
  },
  {
    id: 'research-and-education',
    title: 'montefiore.researchAndEducation',
    links: researchAndEducationLinks,
  },
  {
    id: 'connect',
    title: 'montefiore.connect',
    links: connectLinks,
  },
  {
    id: 'about',
    title: 'montefiore.about',
    links: aboutLinks,
  },
];
